import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import {
  StyledWrapper,
  StyledHeader,
  StyledMenuWrapper,
} from './DrawerNavbar.styled';
import LinkButton from '../../../button/LinkButton';
import HomeButton from '../../../button/HomeButton';
import ThemeSwitch from '../../../button/ThemeSwitch';
import LanguageSelect from '../../../button/LanguageSelect';
import { DropdownButton } from '../../components';
import LinkItem from '../../../button/LinkItem';
import Divider from '@material-ui/core/Divider';
import { baseUrl } from '../../../../config/baseUrl';
import { StyledExitToAppIcon } from '../../Navbar.styled';
import { adminUserService } from '../../../../services';

const DrawerNavbar = (props) => {
  const { open, onClose, currentPath } = props;

  const isSignIn = localStorage.getItem('token');

  const handleClickSignOut = () => {
    onClose();
    adminUserService.signOut();
  };

  return (
    <div>
      <Drawer anchor='left' open={open} onClose={onClose}>
        <StyledWrapper>
          <StyledHeader>
            <HomeButton onClick={onClose} />
            <LinkButton onClick={onClose} to={baseUrl} active={!currentPath}>
              Home
            </LinkButton>
            <LanguageSelect />
            <ThemeSwitch />
            {isSignIn && currentPath && currentPath.includes('admin') && (
              <StyledExitToAppIcon onClick={handleClickSignOut} />
            )}
          </StyledHeader>
          <Divider />
          <div>
            <StyledMenuWrapper>
              <LinkItem
                to={`${baseUrl}mobile-app`}
                active={currentPath === 'mobile-app'}
              >
                Utraffic Mobile
              </LinkItem>
              <LinkItem href='https://bktraffic.com/utraffic/'>
                Utraffic Website
              </LinkItem>
              <LinkItem href='https://bktraffic.com/'>VoH Website</LinkItem>
              <LinkItem
                to={`${baseUrl}public-data`}
                active={currentPath === 'public-data'}
              >
                Public Data
              </LinkItem>
              <LinkItem
                active={currentPath?.includes('collect-data')}
                to={`${baseUrl}collect-data`}
              >
                Collect Data
              </LinkItem>
              <LinkItem
                active={currentPath?.includes('admin')}
                to={`${baseUrl}admin`}
              >
                Admin
              </LinkItem>
              <DropdownButton
                label='Documents'
                active={
                  currentPath === 'publications' ||
                  currentPath === 'publications/thesis' ||
                  currentPath?.includes('apis')
                }
              >
                <LinkItem
                  active={
                    currentPath === 'publications' ||
                    currentPath === 'publications/thesis'
                  }
                  to={`${baseUrl}publications`}
                  isInDropdown
                >
                  Publication
                </LinkItem>
                <LinkItem
                  active={currentPath?.includes('apis')}
                  to={`${baseUrl}apis/intro`}
                  isInDropdown
                >
                  APIS
                </LinkItem>
              </DropdownButton>
            </StyledMenuWrapper>
          </div>
        </StyledWrapper>
      </Drawer>
    </div>
  );
};

DrawerNavbar.propTypes = {
  open: PropTypes.bool,
};

export default DrawerNavbar;
